import { createRoute } from '@tanstack/react-router';
import { t } from 'i18next';
import React from 'react';

import { AccessGuard } from 'src/guards/AccessGuard';
import { AuthGuard } from 'src/guards/AuthGuard';
import { NotFoundFeature } from 'src/pages/errors/NotFoundFeature';
import { ForecastDefaultPage } from 'src/pages/forecast/ForecastDefaultPage';
import { ForecastPage } from 'src/pages/forecast/ForecastPage';
import { ForecastSkuPage } from 'src/pages/forecast/ForecastSkuPage';
import { RootRoute } from 'src/routes/__root';

export const ForecastRoute = createRoute({
  getParentRoute: () => RootRoute,
  path: '/forecast',
  validateSearch: (search: Record<string, unknown>) => {
    return {
      sessionId:
        typeof search.sessionId === 'string' ? search.sessionId : undefined,
    };
  },
  component: () => (
    <AuthGuard>
      <AccessGuard>
        <ForecastPage />
      </AccessGuard>
    </AuthGuard>
  ),
  notFoundComponent: () => (
    <NotFoundFeature
      route='/forecast'
      routeTitle={t('Go to the forecast', { ns: 'errors' })}
    />
  ),
});

export const ForecastDefaultRoute = createRoute({
  getParentRoute: () => ForecastRoute,
  path: '/',
  component: ForecastDefaultPage,
});

export const ForecastSkuRoute = createRoute({
  getParentRoute: () => ForecastRoute,
  path: '/$sku',
  component: ForecastSkuPage,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      sessionId:
        typeof search.sessionId === 'string' ? search.sessionId : undefined,
    };
  },
});
